module.exports = __webpack_public_path__ + "static/media/free-underline-teal.a13664cb.svg";